"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
var FormHelperText = function (_a) {
    var classes = _a.classes, children = _a.children, _b = _a.component, component = _b === void 0 ? 'p' : _b, disabled = _a.disabled, error = _a.error, filled = _a.filled, focused = _a.focused, margin = _a.margin, required = _a.required, variant = _a.variant;
    return (react_1.default.createElement(FormHelperText_1.default, { classes: classes, component: component, disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant }, children));
};
exports.default = FormHelperText;
